import axios from "axios";
import { API_URL } from "constants";

export const createAssetsTypes = async (formData, companyId) => {
  const url = `${API_URL}/${companyId}/assets/types/post`;
  return axios.post(url, formData).then((response) => response.data);
};

export const updateAssetsTypes = async (formData, companyId) => {
  const url = `${API_URL}/${companyId}/assets/types/${formData.id}`;
  return axios.patch(url, formData).then((response) => response.data);
};

export const fetchAssetsTypes = async (companyId, filtersValue = {}) => {
  const params = new URLSearchParams();
  const textSearch =
    typeof filtersValue?.textSearch === "string"
      ? filtersValue.textSearch.trim()
      : "";
  if (textSearch) {
    params.set("textSearch", textSearch);
  }
  const queryString = params.toString();
  const url = `${API_URL}/${companyId}/assets/types/fetch${
    queryString ? `?${queryString}` : ""
  }`;
  return axios.get(url).then((response) => response.data);
};
